// noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
export function isIe() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ");
  return msie !== -1;
}

global.isIe = isIe;
